import React from 'react';
const ClientLogos = () => {
  const logos = [{
    name: 'CVS Health',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ePKfoGgmweyvuY4gJA32dL/CVS_Health_Logo.svg.png'
  }, {
    name: 'Mastercard',
    url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/1280px-Mastercard-logo.svg.png'
  }, {
    name: 'IBM',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vWuzyrzQkJV6oWJCiobh1q/IBM_logo.png'
  }, {
    name: 'T-Systems',
    url: 'https://cdn.magicpatterns.com/uploads/iPQr4qMQ816YHgxVzQv7fH/T-Systems_Logo_2024.svg.png'
  }];
  return <section className="py-8 md:py-12 bg-lightgray bg-opacity-30" data-id="element-47">
      <div className="container mx-auto px-4 md:px-12" data-id="element-48">
        <div className="flex justify-center items-center gap-12 md:gap-24 flex-wrap" data-id="element-49">
          {logos.map((logo, index) => <div key={index} className="flex justify-center items-center" data-id="element-50">
              <img src={logo.url} alt={`${logo.name} logo`} className={`${logo.name === 'T-Systems' ? 'h-8 md:h-11' : 'h-10 md:h-14'} max-w-[120px] md:max-w-[160px] w-auto object-contain grayscale opacity-70 hover:opacity-100 transition-opacity duration-300`} data-id="element-51" />
            </div>)}
        </div>
      </div>
    </section>;
};
export default ClientLogos;